/*
 * @Author: cn1994
 * @Date: 2023-09-17 13:45:04
 * @LastEditors: cn1994
 * @LastEditTime: 2024-03-03 15:08:30
 * @Description: file content
 */
// 积分兑奖
const routes = [
  // 积分兑奖首页
  {
    path: '/award',
    name: 'award',
    meta: {
      title: '积分兑奖',
      volcengine: true,
    },
    component: () => import('@/pages/award/awardHome.vue')
  },
  {
    path: '/award/teacherPointsDetail',
    name: 'teacherPointsDetail',
    meta: {
      title: '赠送积分详情'
    },
    component: () => import('@/pages/award/points/teacherPointsDetail.vue'),
  },
]

export default routes